import Vue from "vue";
import Component from "vue-class-component";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "OfflineStatus" })
export default class OfflineStatus extends Vue {
    public localizer: any = Localizer;

    get status() {
        return this.$store.getters["offlineStore/status"];
    }

    get downloadPercentage() {
        return this.$store.getters["offlineStore/downloadPercentage"];
    }
};